/* eslint-disable no-unused-vars */

/**
 * Error Contexts
 * @readonly
 * @enum {string}
 */
const ERROR_CONTEXTS = {
  /** An error that occurred before the candidate can start the assessment */
  load: 'load',
  /** A repeated error saving the solution */
  saveSolution: 'saveSolution',
  /** A repeated error submitting a project challenge solution */
  submitSolution: 'submitSolution',
  /** A repeated error submitting the entire assessment */
  submitAssessment: 'submitAssessment',
};

// Note: JSDoc cannot handle exporting an enum directly, so it has to be separate like this.
export const ERROR_CONTEXT = ERROR_CONTEXTS;
